import { render } from "./TaskBranch.vue?vue&type=template&id=1ac362ca"
import script from "./TaskBranch.vue?vue&type=script&lang=js"
export * from "./TaskBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__